import { render, staticRenderFns } from "./derated.vue?vue&type=template&id=d63c97da&"
import script from "./derated.vue?vue&type=script&lang=js&"
export * from "./derated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports